<template>
  <div class="ordenes-proveedores-datos">
    <b-row>
      <b-col cols="12" xl="12">  
        <b-card header="Información de la Orden">
          <b-table 
              class="data-display"
              small 
              responsive="sm" 
              :items="ordenProveedorDatos" 
              :fields="fields">
            <template v-slot:cell(valor)="data">
              {{ formattedData(data.item) }}
            </template>
          </b-table>
        </b-card>

        <b-card header="Información de las Ordenes de Trabajo / Subtrabajos" v-if="ordenProveedorRenglones.length != 0">
          <b-table 
              class="registro-ordenes ordenes-trabajo"
              small 
              responsive="sm" 
              :items="ordenProveedorRenglones" 
              :fields="ordenesFields">
            <template v-slot:cell(montoTotal)="data">
              {{ data.item.montoTotal | moneda(data.item.moneda) }}
            </template>

            <template v-slot:cell(detailShowing)="row">
              <b-btn class="detailShowing" 
                  size="sm" 
                  v-if="row.item.descripcion != '' || row.item.descripcionProduccion != ''"
                  @click.stop="row.toggleDetails">
                {{ ( row.detailsShowing) ? '-' : '+' }}
              </b-btn>            
            </template>

            <template v-slot:row-details="row">
              <b-row v-if="row.item.descripcion != ''">
                <b-col cols="12">
                  <p class="descripcion">{{ row.item.descripcion }}</p>
                </b-col>
              </b-row>
              <b-row v-if="row.item.descripcionProduccion != ''">
                <b-col cols="12">
                  <p class="descripcion">{{ row.item.descripcionProduccion }}</p>
                </b-col>
              </b-row>
            </template>
          </b-table>
        </b-card>

        <b-card header="Información de las Ordenes de Trabajo Internas" v-if="ordenProveedorRenglonesInternas.length != 0">
          <b-table 
              class="registro-ordenes ordenes-trabajo-internas"
              small 
              responsive="sm" 
              :items="ordenProveedorRenglonesInternas" 
              :fields="ordenesInternasFields">
            <template v-slot:cell(montoTotal)="data">
              {{ data.item.montoTotal | moneda(data.item.moneda) }}
            </template>

            <template v-slot:cell(detailShowing)="row">
              <b-btn class="detailShowing" 
                  size="sm" 
                  v-if="row.item.observaciones != ''"
                  @click.stop="row.toggleDetails">
                {{ ( row.detailsShowing) ? '-' : '+' }}
              </b-btn>            
            </template>

            <template v-slot:row-details="row">
              <b-row>
                <b-col cols="12">
                  <p class="descripcion">{{ row.item.observaciones }}</p>
                </b-col>
              </b-row>
            </template>
          </b-table>
        </b-card>
        
        <b-card header="Información de la Forma de Pago">
          <b-table 
              class="registro-ordenes"
              small 
              responsive="sm" 
              :items="ordenProveedorFormaPagoDatos" 
              :fields="formasPagoFields">
            <template v-slot:cell(porcentaje)="data">
              {{ data.item.porcentaje | numero(2, true) }}
            </template>
          </b-table>
        </b-card>

        <b-card header="Evaluación al Proveedor" v-if="ordenProveedorEvaluacionDatos.length != 0">
          <b-table 
              class="data-display"
              small 
              responsive="sm" 
              :items="ordenProveedorEvaluacionDatos" 
              :fields="fields">
            <template v-slot:cell(valor)="data">
              {{ formattedData(data.item) }}
            </template>
          </b-table>
        </b-card>
      </b-col>
    </b-row>

    <div class="fixed-btn">
      <div class="data-goback-btn" @click.prevent="goBack">
          <i class="fa fa-undo fa-2x" aria-hidden="true"></i>
      </div>
    </div>

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>
  </div>
</template>

<script>
import Mensaje from  '../shared/msjModal.vue';
import { msjModal } from '../../mixins/modalDialogs'
import { createHelpers } from 'vuex-map-fields';

const { mapFields } = createHelpers({
  getterType: 'ordenproveedor/getField',
  mutationType: 'ordenproveedor/updateField',
});

export default {
  name: 'OrdenProveedor',
  components: {
    appMensaje: Mensaje
  },
  mixins: [
    msjModal
  ],
  data: () => {
    return {
      ordenProveedorId: 0,
      fields: [
        {key: 'campo'},
        {key: 'valor'},
      ],
      ordenesFields: [
        {
          key: 'detailShowing',
          label: '',
          class: 'text-center'
        },
        // {
        //   key: 'presupuestoInternoId',
        //   label: 'Nro.PI'
        // },
        {
          key: 'presupuestoNumero',
          label: 'Nro.PI'
        },
        {
          key: 'ordenTrabajoId',
          label: 'Nro.Orden'
        },
        {key: 'ordenTrabajo'},
        {
          key: 'ordenSubtrabajoId',
          label: 'Nro.Subtrabajo'
        },
        {
          key: 'articuloTipo',
          label: 'Tipo de Artículo'
        },
        {
          key: 'cantidad',
          class: 'text-right'
        },
        {
          key: 'montoTotal',
          class: 'text-right'
        },
      ],
      ordenesInternasFields: [
        {
          key: 'detailShowing',
          label: '',
          class: 'text-center'
        },
        // {
        //   key: 'ordenTrabajoInternaId',
        //   label: 'Nro.Orden'
        // },
        {
          key: 'articuloTipo',
          label: 'Tipo de Artículo'
        },
        {
          key: 'cantidad',
          class: 'text-right'
        },
        {
          key: 'montoTotal',
          class: 'text-right'
        },
      ],
      formasPagoFields: [
        { key: 'formaPago' },
        { 
          key: 'porcentaje',
          class: 'text-right'
        },
        { key: 'condiciones' },
        {
          key: 'opciones',
          label: '',
          class: 'text-center'
        },
      ],

      ordenProveedorRenglones: [],
      ordenProveedorRenglonesInternas: [],
    }
  },
  created() {
    this.ordenProveedorId = this.$route.params.id;

    this.showSpinner();
    this.$store.dispatch('ordenproveedor/getDatos', this.ordenProveedorId)
      .then(() => {
        this.ordenProveedorRenglones = this.$store.getters['ordenproveedor/ordenProveedorRenglones'];
        this.ordenProveedorRenglonesInternas = this.$store.getters['ordenproveedor/ordenProveedorRenglonesInternas'];
      })
      .catch(error => this.showErrorMsj(error))
      .finally(() => this.hideSpinner());
  },  
  computed: {
    ...mapFields([
      'ordenProveedorDatos',
      // 'ordenProveedorRenglonDatos',
      'ordenProveedorFormaPagoDatos',
      'ordenProveedorEvaluacionDatos'
    ]),
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
  }
}
</script>

<style>
  .ordenes-proveedores-datos .data-display table td[aria-colindex="1"] {
    width: 20%;
  }
  .ordenes-proveedores-datos .data-display table td[aria-colindex="2"] {
    width: 80%;
  }

  .ordenes-proveedores-datos .registro-ordenes table td {
    vertical-align: middle;
    border-top: 1px solid #c8ced3 !important;
  }
  .ordenes-proveedores-datos .registro-ordenes.ordenes-trabajo table td[aria-colindex="1"] {
    width: 40px;
  }
  .ordenes-proveedores-datos .registro-ordenes.ordenes-trabajo table td[aria-colindex="2"] {
    width: 5%;
  }
  .ordenes-proveedores-datos .registro-ordenes.ordenes-trabajo table td[aria-colindex="3"] {
    width: 5%;
  }
  .ordenes-proveedores-datos .registro-ordenes.ordenes-trabajo table td[aria-colindex="4"] {
    width: calc(35% - 40px);
  }
  .ordenes-proveedores-datos .registro-ordenes.ordenes-trabajo table td[aria-colindex="5"] {
    width: 5%;
  }
  .ordenes-proveedores-datos .registro-ordenes.ordenes-trabajo table td[aria-colindex="6"] {
    width: 35%;
  }
  .ordenes-proveedores-datos .registro-ordenes.ordenes-trabajo table td[aria-colindex="7"] {
    width: 5%;
  }
  .ordenes-proveedores-datos .registro-ordenes.ordenes-trabajo table td[aria-colindex="8"] {
    width: 10%;
  }

  .ordenes-proveedores-datos .registro-ordenes.ordenes-trabajo-internas table td[aria-colindex="1"] {
    width: 40px;
  }
  .ordenes-proveedores-datos .registro-ordenes.ordenes-trabajo-internas table td[aria-colindex="2"] {
    width: calc(75% - 40px);
  }
  .ordenes-proveedores-datos .registro-ordenes.ordenes-trabajo-internas table td[aria-colindex="3"] {
    width: 10%;
  }
  .ordenes-proveedores-datos .registro-ordenes.ordenes-trabajo-internas table td[aria-colindex="4"] {
    width: 15%;
  }

  .ordenes-proveedores-datos .registro-ordenes.ordenes-trabajo table p.descripcion {
    margin-bottom: 5px;
    padding-left: 9%;
    width: 40%;
    white-space: pre-wrap;
  }
  .ordenes-proveedores-datos .registro-ordenes.ordenes-trabajo-internas table p.descripcion {
    margin-bottom: 5px;
    padding-left: 40px;
    width: 40%;
    white-space: pre-wrap;
  }

</style>
